import React from "react";
import dh from "../../../helpers/date.helper";
import isNaN from "lodash/isNaN";

const dateDataCell =
  ({ attr }) =>
  ({ item: { [attr]: date } }) => {
    if (isNaN(new Date(date).getTime())) return null;

    return <span className="fs-90">{dh.getFormattedDate(date)}</span>;
  };

export default dateDataCell;



// WEBPACK FOOTER //
// ./src/components/cms/gridComponents/dateDataCell.js